import {
  useWSModalCustom,
  WSActionsButton,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { BulkActionProgressCard } from "../components/BulkActionProgressCard";
import { BulkActionProgress } from "../types";
import compact from "lodash/compact";

type Props = {
  actionName: string;
  result: BulkActionProgress;
  nextAction?: WSActionsButton;
  secondaryAction?: WSActionsButton;
} & WSModalCustomProps<void>;

const ModalBulkActionResults: React.FC<Props> = props => {
  const handleSecondaryAction = useCallback<
    NonNullable<WSActionsButton["onClick"]>
  >(
    event => {
      props.secondaryAction?.onClick?.(event);
      props.onClose();
    },
    [props]
  );

  const handleNextAction = useCallback<NonNullable<WSActionsButton["onClick"]>>(
    event => {
      props.nextAction?.onClick?.(event);
      props.onClose();
    },
    [props]
  );

  const showNextAction = !!props.nextAction && props.result.successful > 0;

  const secondaryButton: WSActionsButton = {
    kind: "Secondary",
    label: "Done",
    type: "button",
    ...props.secondaryAction,
    onClick: handleSecondaryAction
  };

  const nextAction: WSActionsButton | undefined = showNextAction
    ? {
        kind: "Primary",
        type: "button",
        ...props.nextAction,
        onClick: handleNextAction
      }
    : undefined;

  const buttons = compact([secondaryButton, nextAction]);

  return (
    <WSModal
      title={props.actionName}
      onClose={() => props.onClose()}
      actions={{
        alignment: "fill",
        buttons
      }}
    >
      <WSList gap="M">
        <WSText.ParagraphSm color="gray500">
          Bulk action results:
        </WSText.ParagraphSm>

        <BulkActionProgressCard progress={props.result} />
      </WSList>
    </WSModal>
  );
};

export const useModalBulkActionResults = () =>
  useWSModalCustom(ModalBulkActionResults);
